module.exports = __webpack_public_path__ + "ee07d91e54d1adb0b75305b209f513d9.png";